// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import ElementUI from 'element-ui'
import * as data from './data/data'
import api from './fetch/api'
import axios from 'axios'
import means from './means/means'
var md5 = require('./means/md5')
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/ele_checked.scss'
import "./assets/css/ele_input.scss";
import "./assets/css/ele_textarea.scss";
import "./assets/css/ele_radio.scss";
import "./assets/css/ele_icon.scss";
import "./assets/css/ele_select.scss";
import './data/areaData'

Vue.use(ElementUI)

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$hwdata = data;
Vue.prototype.$means = means;
Vue.prototype.$http = axios;

Vue.prototype.$md5 = md5;
//图片延迟加载指令
Vue.directive('img',{
  inserted : function (el,binding) {
    if(binding.value){
      if(el.tagName == 'IMG'){
        el.src = LOADINGIMG;
      }else{
        el.style.backgroundImage = `url(${LOADINGIMG})`;
      }
      let img = new Image();
      img.src = binding.value;
      img.onload = function () {
        if(el.tagName == 'IMG'){
          el.src = `${binding.value}`;
        }else{
          el.style.backgroundImage = `url(${binding.value})`;
        }
      }
    }
  },
  update : function (el,binding) {
    if(binding.value){
      if(el.tagName == 'IMG'){
        el.src = LOADINGIMG;
      }else{
        el.style.backgroundImage = `url(${LOADINGIMG})`;
      }
      let img = new Image();
      img.src = binding.value;
      img.onload = function () {
        if(el.tagName == 'IMG'){
          el.src = `${binding.value}`;
        }else{
          el.style.backgroundImage = `url(${binding.value})`;
        }
      }
    }
  }
})

// 只能输入整数字
Vue.directive('enterNumber', {
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
          if(e.preventDefault){
              e.preventDefault();
          }else{
              e.returnValue = false;
          }
      }
    });
  }
});

//图片延迟加载指令1 不更新
Vue.directive('img1',{
  inserted : function (el,binding) {
    if(binding.value){
      if(el.tagName == 'IMG'){
        el.src = LOADINGIMG;
      }else{
        el.style.backgroundImage = `url(${LOADINGIMG})`;
      }
      let img = new Image();
      img.src = binding.value;
      img.onload = function () {
        if(el.tagName == 'IMG'){
          el.src = `${binding.value}`;
        }else{
          el.style.backgroundImage = `url(${binding.value})`;
        }
      }
    }
  }
})

Vue.directive('enterNumber2', {
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if(charcode == 46){
        if(el.value.includes('.')){
          e.preventDefault();
        }
        return;
      }else if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
        if(e.preventDefault){
          e.preventDefault();
        }else{
            e.returnValue = false;
        }
      }
    });
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js